import React from 'react'
import { useTranslation } from 'react-i18next'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Typography from '@material-ui/core/Typography'

import { formatNumber } from 'libraries/utils'

const FeeTable = props => {
	const { t } = useTranslation();
	const { data } = props
	const total = data.get('feeDetail').reduce((acc, curr) => acc + curr.get('amount'), 0)
	return (
		<Table>
			<TableHead>
				<TableRow>
					<TableCell style={{paddingLeft: '30px'}}>{t('fee_item')}</TableCell>
					<TableCell>{t('fee')}</TableCell>
					<TableCell>{t('amount')}</TableCell>
					<TableCell>{t('price')}</TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{data.get('feeDetail').map((detail, idx) => (
					<TableRow key={idx}
						style={{borderBottom: '1px solid rgba(74, 79, 85, 0.1)'}}
					>
						<TableCell style={{paddingLeft: '30px'}}>
							{detail.get('orderNo')}
						</TableCell>
						<TableCell>
							${formatNumber(detail.get('unitPrice'))}{t('fee_unit_price')}
						</TableCell>
						<TableCell>
							{detail.get('bottles')}
						</TableCell>
						<TableCell>
							${formatNumber(detail.get('amount'))}
						</TableCell>
					</TableRow>
				))}

				<TableRow className="total-block">
					<TableCell colSpan={2} />
					<TableCell colSpan={1} align="right" className="title">{t('total')}</TableCell>
					<TableCell colSpan={1}>${formatNumber(total)}</TableCell>
				</TableRow>

				{/* 扣抵 */}
				<TableRow className="total-block">
					<TableCell colSpan={2}>
						{!!data.get('coupon') &&
							`${data.getIn(['coupon', 'name'])} - ${data.getIn(['coupon', 'description'])}`
						}
					</TableCell>
					<TableCell colSpan={1} align="right" className="title">{t('coupon_fee')}</TableCell>
					<TableCell colSpan={1} >
						<Typography color={!!data.getIn(['coupon', 'couponAmount']) ? 'error' : 'initial'}>
							{!!data.getIn(['coupon', 'couponAmount']) ?
								`-${formatNumber(data.getIn(['coupon', 'couponAmount']))}`
								:
								'-'
							}
						</Typography>
					</TableCell>
				</TableRow>

				<TableRow className="total-block">
					<TableCell colSpan={2} />
					<TableCell colSpan={1} align="right" className="title">{t('total_amount')}</TableCell>
					<TableCell colSpan={1}>${formatNumber(data.get('amount'))}</TableCell>
				</TableRow>

			</TableBody>
		</Table>
	)
}

export default FeeTable
